export type ProductFilterableOffer = {
  eligibleProducts?: string[];
};

/**
 * Filters wallet offers down to those applicable to a given product
 * (e.g. `EligibleProduct.Lodging` for hotels).
 *
 */
export const filterOffersForProduct = <T extends ProductFilterableOffer>(
  offers: T[],
  product: string
): T[] => offers.filter((offer) => offer.eligibleProducts?.includes(product));
